module.exports = __webpack_public_path__ + "static/media/logo1.b91d28de.png";